import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Mail, MapPin } from 'lucide-react';

export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#0d1117] py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Back button */}
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#8b949e] hover:text-[#ff6b00] transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Назад на маркет</span>
        </Link>

        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <Shield className="w-8 h-8 text-[#ff6b00]" />
          <h1 className="text-3xl font-bold text-white">Политика конфиденциальности</h1>
        </div>

        {/* Legal entity info */}
        <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-6 mb-8">
          <h2 className="text-lg font-semibold text-white mb-4">Оператор персональных данных</h2>
          <div className="space-y-2 text-[#8b949e]">
            <p><span className="text-[#c9d1d9]">Наименование:</span> MEGA PANDA, LLC</p>
            <p><span className="text-[#c9d1d9]">Регистрационный номер (NCR):</span> 0000999047</p>
            <p><span className="text-[#c9d1d9]">Юридический адрес:</span> UL. BOHATERÓW MONTE CASSINO 39-14, PL-81-767, SOPOT, POLAND</p>
          </div>
        </div>

        {/* Content */}
        <div className="prose prose-invert max-w-none">
          <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-6 space-y-6">
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. Общие положения</h2>
              <p className="text-[#8b949e] leading-relaxed">
                Настоящая Политика конфиденциальности регулирует порядок обработки и защиты персональных данных пользователей 
                сайта Xpanda Market (далее — «Сайт»). Оператором персональных данных является MEGA PANDA, LLC, 
                зарегистрированная по адресу: UL. BOHATERÓW MONTE CASSINO 39-14, PL-81-767, SOPOT, POLAND.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                Используя Сайт, Пользователь выражает согласие с условиями настоящей Политики конфиденциальности. 
                В случае несогласия с условиями Политики Пользователь должен прекратить использование Сайта.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. Персональные данные, которые мы собираем</h2>
              <p className="text-[#8b949e] leading-relaxed mb-2">
                Мы можем собирать следующие категории персональных данных:
              </p>
              <ul className="list-disc list-inside text-[#8b949e] space-y-1 ml-2">
                <li>Steam ID и данные профиля Steam (никнейм, аватар, ссылка на профиль)</li>
                <li>Адрес электронной почты</li>
                <li>Steam Trade URL для передачи предметов</li>
                <li>История покупок и продаж на платформе</li>
                <li>IP-адрес и данные об используемом устройстве</li>
                <li>Информация о платежных операциях (без хранения данных банковских карт)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. Цели обработки персональных данных</h2>
              <p className="text-[#8b949e] leading-relaxed mb-2">
                Персональные данные обрабатываются в следующих целях:
              </p>
              <ul className="list-disc list-inside text-[#8b949e] space-y-1 ml-2">
                <li>Регистрация и аутентификация пользователей через Steam</li>
                <li>Выполнение договорных обязательств по купле-продаже игровых предметов</li>
                <li>Передача приобретенных предметов через Steam Trade URL</li>
                <li>Обработка платежей и управление балансом пользователя</li>
                <li>Коммуникация с пользователями (уведомления, поддержка)</li>
                <li>Улучшение работы Сайта и персонализация пользовательского опыта</li>
                <li>Предотвращение мошенничества и обеспечение безопасности</li>
                <li>Выполнение требований законодательства</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. Правовые основания обработки</h2>
              <p className="text-[#8b949e] leading-relaxed">
                Обработка персональных данных осуществляется на основании согласия пользователя, 
                а также в случаях, когда обработка необходима для исполнения договора, 
                заключенного с пользователем, или для выполнения требований законодательства.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. Передача данных третьим лицам</h2>
              <p className="text-[#8b949e] leading-relaxed mb-2">
                Мы не продаем персональные данные пользователей. Данные могут быть переданы третьим лицам только в следующих случаях:
              </p>
              <ul className="list-disc list-inside text-[#8b949e] space-y-1 ml-2">
                <li>Платежным провайдерам для обработки транзакций</li>
                <li>Steam (Valve Corporation) для выполнения торговых операций</li>
                <li>Правоохранительным органам по законному требованию</li>
                <li>Службам аналитики (в обезличенном виде)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. Хранение и защита данных</h2>
              <p className="text-[#8b949e] leading-relaxed">
                Персональные данные хранятся на защищенных серверах, расположенных в соответствии 
                с требованиями законодательства. Мы применяем современные технические и организационные 
                меры для защиты данных от несанкционированного доступа, изменения, раскрытия или уничтожения.
              </p>
              <p className="text-[#8b949e] leading-relaxed mt-2">
                Данные хранятся в течение срока, необходимого для достижения целей обработки, 
                но не более 5 лет с момента последней активности пользователя.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. Права пользователей</h2>
              <p className="text-[#8b949e] leading-relaxed mb-2">
                Пользователь имеет право:
              </p>
              <ul className="list-disc list-inside text-[#8b949e] space-y-1 ml-2">
                <li>Получить информацию о своих персональных данных</li>
                <li>Требовать исправления неточных данных</li>
                <li>Требовать удаления данных (право «быть забытым»)</li>
                <li>Отозвать согласие на обработку данных</li>
                <li>Ограничить обработку данных</li>
                <li>Получить свои данные в машиночитаемом формате</li>
                <li>Подать жалобу в надзорный орган</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. Использование cookies</h2>
              <p className="text-[#8b949e] leading-relaxed">
                Сайт использует файлы cookies для обеспечения работоспособности, анализа посещаемости 
                и персонализации контента. Пользователь может отключить cookies в настройках браузера, 
                однако это может повлиять на функциональность Сайта.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">9. Изменения политики</h2>
              <p className="text-[#8b949e] leading-relaxed">
                Мы оставляем за собой право вносить изменения в настоящую Политику конфиденциальности. 
                Изменения вступают в силу с момента их публикации на Сайте. Рекомендуем регулярно 
                проверять актуальную версию Политики.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">10. Контактная информация</h2>
              <p className="text-[#8b949e] leading-relaxed mb-4">
                По всем вопросам, связанным с обработкой персональных данных, обращайтесь:
              </p>
              <div className="bg-[#0d1117] rounded-lg p-4 space-y-3">
                <div className="flex items-center gap-3 text-[#8b949e]">
                  <Mail className="w-5 h-5 text-[#ff6b00]" />
                  <span>site@xpanda.team</span>
                </div>
                <div className="flex items-start gap-3 text-[#8b949e]">
                  <MapPin className="w-5 h-5 text-[#ff6b00] mt-0.5" />
                  <span>MEGA PANDA, LLC<br />UL. BOHATERÓW MONTE CASSINO 39-14<br />PL-81-767, SOPOT, POLAND</span>
                </div>
              </div>
            </section>

            <div className="border-t border-[#30363d] pt-6 mt-6">
              <p className="text-[#6e7681] text-sm">
                Последнее обновление: {new Date().toLocaleDateString('ru-RU')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
